import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import SellersTable from "@/components/sellers/sellers-table";

const sellersSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/sales/sellers/")({
  validateSearch: sellersSearchSchema,
  component: SellersPage,
});

function SellersPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "sellers", actions: ["read"] }]}>
      
    <div>
      <div>
        <SellersTable
          currentPage={searchParams.page}
          pageSize={5}
          basePath="/sales/sellers"
          searchParams={searchParams}
        />
      </div>
    </div>
  
    </RouteGuardPermissions>
  );
}
